/* src/app/@framework/components/Breadcrumb/Breadcrumb.component.less */
zapp-breadcrumb .p-breadcrumb-list .p-menuitem-separator {
  margin: 0 0.5rem 0 0.5rem;
}
zapp-breadcrumb .p-breadcrumb-list homeicon {
  padding: 0 0.5rem 0 0;
}
zapp-breadcrumb .p-breadcrumb-list i.pi {
  padding: 0 0.5rem 0 0;
}
zapp-breadcrumb .p-breadcrumb-list .breadcrumb-intermediate-item {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
zapp-breadcrumb .hide-home-icon homeicon {
  display: none;
}
zapp-breadcrumb .empty-breadcrumbs .p-breadcrumb-separator {
  display: none;
}
.p-tieredmenu .p-menuitem-link {
  padding: 0.75rem 1.25rem;
  border-radius: 0;
  transition: box-shadow 0.2s;
  -webkit-user-select: none;
  user-select: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  text-decoration: none;
  overflow: hidden;
  position: relative;
}
.p-tieredmenu.p-tieredmenu-overlay {
  margin-top: 10px;
  border: 1px solid #d3dce8;
}
.p-tieredmenu.p-tieredmenu-overlay::before {
  content: " ";
  position: absolute;
  top: -10px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #d3dce8;
}
.p-tieredmenu.p-tieredmenu-overlay::after {
  content: " ";
  position: absolute;
  top: -8px;
  left: 22px;
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 8px solid white;
}
/*# sourceMappingURL=Breadcrumb.component.css.map */
